"use client";
import Stack from "@casino/legacy/client/shared/Stack";
import BrandThemeProvider from "../Shared/BrandThemeProvider";
import LoginBody from "./LoginBody";
import LoginBottomLinks from "./LoginBottomLinks";

type Props = {
  isPopover?: boolean;
  onSuccess?: () => void;
};

const Login: FC<Props> = ({ onSuccess, isPopover = false }) => (
  <Stack templateRows="minmax(1px,1fr) minmax(1px,120px)" gridGap="1.5rem">
    <LoginBody isPopover={isPopover} onSuccess={onSuccess} />
    <BrandThemeProvider hasBombayClubTheme={isPopover}>
      <LoginBottomLinks isPopover={isPopover} />
    </BrandThemeProvider>
  </Stack>
);

export default Login;
